import { render, staticRenderFns } from "./FieldFile.vue?vue&type=template&id=1ff10e08&scoped=true&"
import script from "./FieldFile.vue?vue&type=script&lang=js&"
export * from "./FieldFile.vue?vue&type=script&lang=js&"
import style0 from "./FieldFile.vue?vue&type=style&index=0&id=1ff10e08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff10e08",
  null
  
)

export default component.exports